import React from 'react';

type Props = {
	percent: number;
	colorMode: string;
};

const DiscountBadge = ({ percent, colorMode }: Props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='68.252'
			height='78.393'
			viewBox='0 0 68.252 78.393'
		>
			<g id='Discount1' transform='translate(-256 -2553.994)'>
				<path
					id='Path_20438'
					data-name='Path 20438'
					d='M0,0V64.74L34.126,78.393,68.252,64.74V0Z'
					transform='translate(256 2553.994)'
					fill={
						colorMode === 'dark' ? 'var(--colorScale-2)' : 'var(--colorScale-0)'
					}
				/>
				<g
					id='Group_35009'
					data-name='Group 35009'
					transform='translate(256 2553.994)'
				>
					<text
						id='DISCOUNT'
						transform='translate(10 24.006)'
						fill='#fff'
						font-size='10'
						font-family='Roboto-Medium, Roboto'
						font-weight='500'
					>
						<tspan x='0' y='0'>
							DISCOUNT
						</tspan>
					</text>
					<text
						id='_50_'
						data-name='50%'
						transform='translate(8 50.006)'
						fill='#fff'
						font-size='28'
						font-family='Roboto-Medium, Roboto'
						font-weight='500'
					>
						<tspan x='0' y='0'>
							{percent ?? 50}%
						</tspan>
					</text>
				</g>
			</g>
		</svg>
	);
};

export default DiscountBadge;
